import { Helpers } from '@bode-canada/core';
import createMarketDataFilterForm
  from '@/components/features/market-data/components/filters/MarketDataFiltersFormControls';
import MarketDataFilterFormQueryMapper
  from '@/components/features/market-data/mapper/MarketDataFilterFormQueryMapper';
import FetchMarketData from '@/components/features/market-data/mixins/FetchMarketData';
import FilterMapper from '@/components/page-specific/market-data/mappers/filters';

// @vue/component
const HandleMarketDataForm = {
  mixins: [FetchMarketData],
  data() {
    return {
      filtersForm: createMarketDataFilterForm(),
    };
  },
  methods: {
    initFilterForm() {
      const initialValues = MarketDataFilterFormQueryMapper.mapFromQueries(this.$route.query);

      this.filtersForm.setValue(initialValues);
    },
    handleFiltersSubmit(value) {
      this.loadResultsByFilters(value);
    },
    handleFiltersChange() {
      const query = MarketDataFilterFormQueryMapper.mapToQueries(this.filtersForm.value);

      if (!Helpers.ObjectHelper.isEqual(query, this.$route.query)) {
        this.$router.replace({ query });
      }
    },
    async loadResultsByFilters(value) {
      this.resetMarketData();
      const queryParams = FilterMapper.mapToDto(value);
      await this.loadMarketData(queryParams);
    },
  },
};

export default HandleMarketDataForm;
